import React, { memo, useState } from "react";
import {
	Row, Col,
	Card, CardBody,
	Button,
	Modal, ModalBody, ModalFooter
} from "reactstrap";

import Details from "components/FullTest/MockOperations/ListeningDirectory/Details";
import Questions from "components/FullTest/MockOperations/Questions";

const Listening = memo( function Listening({
	mockData, questions, setSection, pending
}) {

	// Flag: 1 => Section Deatils.
	// Flag: 2 => Questions.
	const [flag, setFlag] = useState(mockData.skip < 2 ? 1 : 2);
	const [currQ, setCurrQ] = useState(-1);

	const sectionTime = () => {
		return pending ? mockData.time : parseInt(mockData.mock.listening_time);
	};

	const nextButton = (e) => {
		// I have removed the pending condition to reload the page
		setFlag(prev => (prev + 1));
		setCurrQ(0);
	};

	return (
		<>
			{flag === 1 &&
				<div className="content questionsArea deviceTestPage">
					<Row>
						<Col xs={12}>
							<Card>
								<CardBody>
									{flag === 1 &&
										<Details
											user={mockData.user_data}
											totalQuestions={questions.length}
											time={parseInt(mockData.mock.listening_time)}
										/>
									}
								</CardBody>
							</Card>
						</Col>

						<Col xs={12}>
							<div className="bottomBtns">
								<Row>
									<Col xs={9}>
										
									</Col>
									<Col xs={3}>
										<Button
											color="primary"
											onClick={nextButton}
											size="xs"
										>NEXT</Button>
									</Col>
								</Row>
							</div>
						</Col>
					</Row>
				</div>
			}

			{flag === 2 &&
				<Questions
					mockData={mockData}
					mock={mockData.mock}
					time={currQ === -1 ? sectionTime() : parseInt(mockData.mock.listening_time)}
					questions={questions}
					setSection={setSection}
					pending={pending}
					skip={3}
					currQ={currQ}
				/>
			}
		</>
	);
});

export default Listening;